import * as fmt from "../operations/formats";

export function setFormat(row, column, format, page){
	return fmt.addFormat(this, row, column, format, null, page);
}

export function setFormatName(row, column, name, page){
	fmt.setFormat(this, row, column, name, page);
}

export function getFormat(row, column, page){
	return fmt.getFormatName(this, row, column, page);
}

export function addFormat(format){
	return fmt.createFormat(this, format);
}

export function removeFormat(row, column, page) {
	fmt.removeFormat(this, row, column, page);
}

export function changeDecimals(row, column, inc, page){
	//row and column may be obj
	fmt.changeAreaDecimals(this, inc, row, column, page);
}